import {
  type ValidatorFunction,
  type ValidatorResult,
} from 'ember-changeset-validations';
import { type ValidityPeriod } from 'uplisting-frontend/transforms/validity-periods';

export function validateValidityPeriods(): ValidatorFunction {
  return (_key, newValue): ValidatorResult => {
    const periods = (
      Array.isArray(newValue) ? newValue : []
    ) as ValidityPeriod[];

    const sorted = periods
      .filter((period) => period.startDate && period.endDate)
      .sort((a, b) => (a.startDate < b.startDate ? -1 : 1));

    return sorted.every((period, index) => {
      const previous = sorted[index - 1];

      return (
        period.startDate <= period.endDate &&
        (previous === undefined || period.startDate > previous.endDate)
      );
    });
  };
}
